var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLegolandOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_legoland_outline_svg__clip0_37861_11143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.675 4.025l3 1c.2.075.35.25.35.475 0 .225-.15.4-.35.475l-1.65.55 3.85 6.975c.075.15.125.325.125.5v14H2V14c0-.175.05-.35.125-.5l4-7.25c.05-.05.075-.1.125-.15V4.5c0-.15.075-.3.2-.4.125-.1.3-.125.45-.075l3 1c.2.075.35.25.35.475 0 .225-.15.4-.35.475L8.05 6.6l3.825 6.9c.075.15.125.325.125.5v3h8v-3c0-.175.025-.35.125-.5l3.9-7.025V4.5c0-.15.075-.3.2-.4.125-.1.3-.125.45-.075zM4 26h6V15H4v11zm8-7v7h2v-3c0-1.1.9-2 2-2s2 .9 2 2v3h2v-7h-8zm10 7h6V15h-6v11zM8 23H6v-2h2v2zm18 0h-2v-2h2v2zM8 19H6v-2h2v2zm18 0h-2v-2h2v2zM4.725 13h4.55L7 8.775 4.725 13zm18 0h4.55L25 8.775 22.725 13z",
    fill: props.color
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_legoland_outline_svg__clip0_37861_11143"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

export default SvgIconLegolandOutline;